<template>
  <div class="position-relative"
       v-if="hasCommodity">
    <div class="left-image">
      <div class="top-image"/>
      <div class="down-image"/>
    </div>
    <div class="right-image"/>
    <div class="bc">
      <div class="main_area">
        <div style="height: 50px;"/>
        <img class="img_title" src="/img/image/home/t_13.png" loading="lazy" alt="立即品嚐">
        <div style="height: 40px;"/>
        <img class="img_main" :src="img" loading="lazy" alt>
        <div style="height: 60px;"/>

        <div class="info_area">
          <div class="row no-gutters text_area">
            <div>
              <span class="text-custom-text font-weight-700 commodity_text">{{ name }}</span>
              <span class="text-custom-text commodity_text">{{ subtitle }}</span>
            </div>
            <div class="text_space"/>
            <span class="text-primary font-weight-500 commodity_text"> 每份售價{{ price }}</span>
            <div class="text_space"/>
          </div>
          <div style="height: 40px;"/>
          <div class="row no-gutters icon_area">
            <button class="btn dec_icon" @click="clickDec"/>
            <div class="col"/>
            <div class="h2 font-weight-900 text-primary"> {{ count }}</div>
            <div class="col"/>
            <button class="btn add_icon" @click="clickAdd"/>
          </div>
          <div style="height: 40px;"/>
          <div class="row no-gutters btn_area">
            <button type="button" class="col btn btn_style" @click="clickBuy">
              <div class="row no-gutters justify-content-center align-items-center">
                <span class="button_text  text-white">去購買</span>
                <div class="button_space"/>
                <img class="button_icon" src="/img/image/icon/arrow.png" loading="lazy" alt>
              </div>
            </button>
          </div>
          <div style="height: 70px;"/>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import {getCommodities} from "@/api/commodity";
import {getMediaUrl, getUrl, isEmpty} from "@/util/helpers";

export default {
  name: "Stage_9",
  data() {
    return {
      count: 1,
      commodities: [],
    };
  },
  computed: {
    hasCommodity() {
      // console.log(this.mainCommodityId)
      // console.log(this.commodities)
      return !!this.commodity;
    },
    name() {
      let val = this.commodity.name;
      return isEmpty(val) ? "" : val;
    },
    subtitle() {
      let val = this.commodity.subtitle;
      return isEmpty(val) ? "" : val;
    },
    price() {
      let val = this.commodity.price;
      return isEmpty(val) ? "" : val;
    },
    img() {
      let val = this.commodity;
      return isEmpty(val) ? "" : getMediaUrl(val);
    },
    settingData() {
      return this.$store.getters.getSettingData;
    },
    mainCommodityId() {
      if (!this.settingData) return null;
      let val = this.settingData.data.main_page_commodity_id;
      return isEmpty(val) ? 0 : val;
    },
    commodity() {
      if (!this.mainCommodityId) return null;
      return this.commodities.find(item => parseInt(item.id) === parseInt(this.mainCommodityId));
    },
    mainCommodityCount() {
      return this.$store.getters.getMainCommodityCount;
    }
  },
  created() {
    this.initData();
  },
  methods: {
    async initData() {
      let response = await getCommodities();
      this.commodities = response.data;
    },
    clickBuy() {
      this.$store.dispatch('setMainCommodityCount', this.count);
      this.$router.push({path: '/buy'});
    },
    clickAdd() {
      if (this.count + 1 >= 100) return;
      this.count += 1;
    },
    clickDec() {
      if (this.count - 1 <= 0) return;
      this.count -= 1;
    }
  },
}
</script>

<style lang="scss" scoped>

.bc {
  margin: 0 auto;
  height: auto;
  max-width: 1440px;
  //text-align: center;
}

@media (max-width: 992px) {
  .bc {
    text-align: center;
  }
}

.left-image, .right-image {
  position: absolute;
  top: 0;
  height: 100%;
  background-size: cover;
  background-position: center;
}


.left-image {
  left: 0;
  width: 66%;
  //background-image: url('/img/image/background/bg_s10.png');
  //clip-path: polygon(0 0, 100% 0%, 85% 100%, 0% 100%); /* 左側圖片的梯形 */
  z-index: -1;
}

@media (max-width: 992px) {
  .left-image {
    width: 100%;
  }
}

.right-image {
  right: 0;
  width: 34%;
  background-image: url('/img/image/background/bg_s15.png');
}

@media (max-width: 992px) {
  .right-image {
    width: 0;
  }
}

.top-image {
  position: absolute;
  width: 100%;
  top: 0;
  height: 45%;
  background-size: cover;
  background-position: center;
  background-image: url('/img/image/background/bg_s10_1.png');
}

@media (max-width: 850px) {
  .top-image {
    height: 35%;
  }
}

@media (max-width: 425px) {
  .top-image {
    height: 30%;
  }
}

.down-image {
  position: absolute;
  width: 100%;
  top: 45%;
  bottom: 0;
  background-size: cover;
  background-position: center;
  background-image: url('/img/image/background/bg_s10_2.png');
}

@media (max-width: 850px) {
  .down-image {
    top: 35%;
  }
}

@media (max-width: 425px) {
  .down-image {
    top: 30%;
  }
}


.main_area {
  width: 66%;
  text-align: center;
}

@media (max-width: 992px) {
  .main_area {
    width: 100%;
  }
}


// 文字 立即品嘗
.img_title {
  width: 300px;
  height: auto;
  object-fit: cover;
}

@media (max-width: 576px) {
  .img_title {
    width: 181px;
  }
}

@media (max-width: 360px) {
  .img_title {
    width: 155px;
  }
}


//圖片 一盤肉
.img_main {
  max-width: 708px;
  width: 708px;
  height: auto;
  object-fit: cover;
}

@media (max-width: 1440px) {
  .img_main {
    //width: 50vw;
  }
}


@media (max-width: 992px) {
  .img_main {
    width: 70vw;
  }
}

@media (max-width: 576px) {
  .img_main {
    width: 82vw;
  }
}

@media (max-width: 360px) {
  .img_main {
    width: 297px;
  }
}


.info_area {
  max-width: 720px;
  width: 50vw;
  margin: 0 auto;
}

@media (max-width: 992px) {
  .info_area {
    width: 72vw;
  }
}

.text_area {
  justify-content: space-between;
}

@media (max-width: 850px) {
  .text_area {
    justify-content: center;
    flex-direction: column-reverse;
    align-items: center;
  }
}

.text_space {
  width: 0;
  height: 0;
}

@media (max-width: 850px) {
  .text_space {
    height: 24px;
  }
}


.icon_area {
  width: 100%;
}

@media (max-width: 576px) {
  .icon_area {
    width: 190px;
    margin: 0 auto;
    align-items: baseline;
  }
}

@media (max-width: 360px) {
  .icon_area {
    width: 120px;
  }
}

.add_icon {
  background: url('/img/image/icon/plus_icon.png') no-repeat center center;
  background-size: cover;
  width: 56px; /* 按钮宽度 */
  height: 56px; /* 按钮高度 */
  cursor: pointer;
  display: inline-block;
}

@media (max-width: 576px) {
  .add_icon {
    padding: 0;
    width: 36px;
    height: 36px;
  }
}

@media (max-width: 360px) {
  .add_icon {
    width: 28px;
    height: 28px;
  }
}

.dec_icon {
  background: url('/img/image/icon/erduce_icon.png') no-repeat center center;
  background-size: cover;
  width: 56px; /* 按钮宽度 */
  height: 56px; /* 按钮高度 */
  cursor: pointer;
  //border: none;
  display: inline-block;
}

@media (max-width: 576px) {
  .dec_icon {
    padding: 0;
    width: 36px;
    height: 36px;
  }
}

@media (max-width: 360px) {
  .dec_icon {
    width: 28px;
    height: 28px;
  }
}


.commodity_text {
  font-family: Noto Sans TC;
  font-size: 30px;
  letter-spacing: 0.1em;
  text-align: left;
}

@media (max-width: 992px) {
  .commodity_text {
    font-size: 28px;
  }
}

@media (max-width: 768px) {
  .commodity_text {
    font-size: 26px;
  }
}

@media (max-width: 576px) {
  .commodity_text {
    font-size: 24px;
  }
}

@media (max-width: 360px) {
  .commodity_text {
    font-size: 18px;
  }
}


.btn_style {
  padding: 9px 30px;
  background-color: #D56835;
  border-radius: 10px;
  border: 4px solid white;
  box-shadow: 0 5px 10px 0 #00000054;
}

.btn_area {
  width: 100%;
}

@media (max-width: 576px) {
  .btn_area {
    width: 190px;
    margin: 0 auto;
  }
}

@media (max-width: 360px) {
  .btn_area {
    width: 120px;
  }
}


.button_text {
  font-family: Noto Sans TC;
  font-size: 24px;
  font-weight: 900;
  letter-spacing: 0.1em;
  text-align: center;
}

@media (max-width: 576px) {
  .button_text {
    font-size: 18px;
  }
}


.button_space {
  width: 16px;
}

@media (max-width: 576px) {
  .button_space {
    width: 0;
    height: 0;
  }
}


.button_icon {
  width: 40px;
  height: 40px
}

@media (max-width: 576px) {
  .button_icon {
    width: 0;
    height: 0;
    visibility: hidden;
  }
}

</style>
